import { Brand } from '@davidlloydleisure/common-js-frontend';

import { BuildType } from 'src/enums/build/build-type';

export const getBrandForBuildType = (buildType: BuildType): Brand => {
  switch (buildType) {
    case BuildType.DAVID_LLOYD_UK:
    case BuildType.DAVID_LLOYD_SPAIN:
    case BuildType.DAVID_LLOYD_BELGIUM:
    case BuildType.DAVID_LLOYD_IRELAND:
    case BuildType.DAVID_LLOYD_LUXEMBOURG:
    case BuildType.DAVID_LLOYD_NETHERLANDS:
    case BuildType.DAVID_LLOYD_ITALY:
    case BuildType.DAVID_LLOYD_FRANCE:
    case BuildType.DAVID_LLOYD_SWITZERLAND:
    case BuildType.DAVID_LLOYD_GERMANY:
      return Brand.DAVID_LLOYD;
    case BuildType.TOGETHER_FOUNDATION:
      return Brand.TOGETHER_FOUNDATION;
    case BuildType.HARBOUR:
      return Brand.HARBOUR;
    case BuildType.MERIDIAN:
      return Brand.MERIDIAN;
  }
};
